import { Colors } from '../../..';
const {
  plum_dark,
  plum_electric,
  new_grey_light,
  white
} = Colors;
export const MAX_LABEL_SIZE = 30;
export const barStyles = {
  fill: true,
  backgroundColor: "".concat(plum_electric, "CC"),
  barThickness: 70,
  borderRadius: Number.MAX_VALUE,
  borderSkipped: false,
  maxBarThickness: 22,
  minBarLength: 200
};
export const gridLinesStyles = {
  color: new_grey_light
};
export const labelStyles = {
  anchor: 'start',
  align: 'end',
  offset: 8,
  color: white
};
export const tooltipStyles = {
  backgroundColor: plum_dark,
  displayColors: false
};
export const labelTextStyles = {
  weight: 'bold',
  size: 12
};